module.exports = __webpack_public_path__ + "static/media/01.564f242b.png";